<template>
  <div v-if="showConsent" class="cookie-consent">
    <div class="cookie-content">
      <div class="cookie-text">
        <span>{{ $t('cookie.message') }}</span>
        <router-link to="/policies" class="privacy-link">{{ $t('cookie.privacy') }}</router-link>
      </div>
      <div class="cookie-buttons">
        <button class="reject-btn" @click="rejectCookies">{{ $t('cookie.reject') }}</button>
        <button class="accept-btn" @click="acceptCookies">{{ $t('cookie.accept') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookieConsent',
  data() {
    return {
      showConsent: false
    }
  },
  mounted() {
    // 检查是否已经做出选择
    const consent = localStorage.getItem('cookieConsent')
    if (!consent) {
      this.showConsent = true
    }
  },
  methods: {
    acceptCookies() {
      localStorage.setItem('cookieConsent', 'accepted')
      this.showConsent = false
    },
    rejectCookies() {
      localStorage.setItem('cookieConsent', 'rejected')
      this.showConsent = false
    }
  }
}
</script>

<style lang="scss" scoped>
.cookie-consent {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  border-top: 1px solid #e0e0e0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  padding: 16px 20px;
}

.cookie-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.cookie-text {
  flex: 1;
  font-size: 14px;
  line-height: 1.5;
  color: #333;
  
  .privacy-link {
    color: #007bff;
    text-decoration: underline;
    margin-left: 4px;
    
    &:hover {
      color: #0056b3;
    }
  }
}

.cookie-buttons {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
}

.reject-btn {
  padding: 8px 20px;
  border: 1px solid #ccc;
  background: #fff;
  color: #666;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: #f8f9fa;
    border-color: #282938;
  }
}

.accept-btn {
  padding: 8px 20px;
  border: none;
  background: #267E75;
  color: #fff;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: #267E75;
  }
}

// 移动端适配
@media (max-width: 768px) {
  .cookie-consent {
    padding: 12px 16px;
  }
  
  .cookie-content {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
  
  .cookie-text {
    text-align: center;
    font-size: 13px;
  }
  
  .cookie-buttons {
    justify-content: center;
  }
  
  .reject-btn,
  .accept-btn {
    flex: 1;
    max-width: 120px;
  }
}
</style> 